import React from "react";
import VideoUpdate from "./VideoUpdate";

export default function YoutubePodcastUpdate({
  selectedCategory = "all",
  moreTo = "/videos?kind=youtube,podcast",
}) {
  return (
    <VideoUpdate
      kinds={["youtube", "podcast"]}
      title="Youtube & Podcast"
      selectedCategory={selectedCategory}
      moreTo={moreTo}
      maxFetch={40}
    />
  );
}